import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    gold: {
      main: "#ffbb42",
      contrastText: "#ffbb42",
    },
    orange: {
      main: "#f7931a",
      contrastText: "#f7931a",
    },
    seagreen: {
      main: "#3bcce0",
      contrastText: "#3bcce0",
    },
    blue: {
      main: "#438afc",
      contrastText: "#438afc",
    },
    red: {
      main: "#ff4a4a",
      contrastText: "#ff4a4a",
    },
    grey: {
      main: "#8f8f8f",
      contrastText: "#8f8f8f",
    },
    green: {
      main: "#83bd67",
      contrastText: "#83bd67",
    },
    purple: {
      main: "#a190ed",
      contrastText: "#a190ed",
    },
    gainsboro: {
      main: "#dcdcdc",
      contrastText: "#dcdcdc",
    }
  },
});

export default theme;